
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("3NFLp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b7c54fef03c1259$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lnvHL = parcelRequire("lnvHL");

var $8LnNu = parcelRequire("8LnNu");

var $6e1cu = parcelRequire("6e1cu");

var $7jTnu = parcelRequire("7jTnu");

var $1KdDN = parcelRequire("1KdDN");

var $lRq8t = parcelRequire("lRq8t");

var $ch9En = parcelRequire("ch9En");

var $2UYvl = parcelRequire("2UYvl");

var $am4Zv = parcelRequire("am4Zv");

var $lJU2B = parcelRequire("lJU2B");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9b7c54fef03c1259$var$MeatballMenu = (0, $2UYvl.lazyAfterPaint)(()=>(parcelRequire("2jB2v")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/issue-operations/meatball-menu/src/ui/index-old.tsx"
});
const $9b7c54fef03c1259$var$Fallback = ({ onRetry: onRetry })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8LnNu.default), {
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, ...props })=>{
            const iconColor = isSelected ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon-subtle, #626F86)";
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lnvHL.default), {
                ...props,
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6e1cu))), {
                    label: "",
                    LEGACY_size: "medium",
                    color: iconColor,
                    LEGACY_primaryColor: iconColor,
                    spacing: "spacious"
                }),
                ref: triggerRef,
                isSelected: isSelected
            });
        },
        placement: "bottom-end",
        shouldRenderToParent: (0, $7jTnu.fg)('should-render-to-parent-should-be-true-empanada')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $am4Zv.ErrorState), {
        onRetry: onRetry
    }));
const $9b7c54fef03c1259$var$AsyncMeatballMenu = (props)=>{
    const [resetCaughtError, setResetCaughtError] = (0, $eJOHy.useState)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorIssueOperations",
        id: "async-meatball-menu",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b7c54fef03c1259$var$Fallback, {
                onRetry: ()=>setResetCaughtError(error)
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-meatball-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lnvHL.default), {
            id: `async-meatball-menu-button-fallback-${props.issueId}`,
            "aria-label": formatMessage((0, $lJU2B.default).disabledMenuButtonLabel, {
                issueKey: props.issueKey
            }),
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6e1cu))), {
                label: "",
                LEGACY_size: "medium",
                color: "currentColor",
                spacing: "spacious"
            }),
            isDisabled: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b7c54fef03c1259$var$MeatballMenu, props)));
};
var $9b7c54fef03c1259$export$2e2bcd8739ae039 = $9b7c54fef03c1259$var$AsyncMeatballMenu;

});
parcelRegister("am4Zv", function(module, exports) {
$parcel$export(module.exports, "ErrorState", () => $ab7c8c7f7d593717$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $lnvHL = parcelRequire("lnvHL");

var $7aL0y = parcelRequire("7aL0y");

var $dPMMf = parcelRequire("dPMMf");

var $lRq8t = parcelRequire("lRq8t");

var $hbIEt = parcelRequire("hbIEt");

var $1vQks = parcelRequire("1vQks");
const $ab7c8c7f7d593717$export$c1ed4f415b9e7023 = ({ onRetry: onRetry })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ab7c8c7f7d593717$var$DropdownItemsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ab7c8c7f7d593717$var$StyledBox, {
        height: (0, $dPMMf.gridSize) * 9,
        iconSize: (0, $dPMMf.gridSize) * 9
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7aL0y))), {
        spacing: "spacious",
        testId: "issue-navigator-issue-operations.common.ui.error-state.error-icon",
        color: "var(--ds-icon, #44546F)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1vQks.StyledText), null, formatMessage((0, $hbIEt.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lnvHL.default), {
        onClick: onRetry,
        appearance: "link"
    }, formatMessage((0, $hbIEt.default).retryMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ab7c8c7f7d593717$var$DropdownItemsWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _1tket9kd _1ul9p3fh _p12fp3fh _c71leo28 _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $ab7c8c7f7d593717$var$StyledBox = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $awdRS.default)(`${__cmplp.height}px`),
            "--_1kpj8xj": (0, $awdRS.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i2nrh _1bah1h6o",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hbIEt", function(module, exports) {
$parcel$export(module.exports, "default", () => $beb51cbc6690af4f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $beb51cbc6690af4f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.retry-message",
        "defaultMessage": "Click to retry"
    }
});

});

parcelRegister("1vQks", function(module, exports) {
$parcel$export(module.exports, "StyledText", () => $cb87d90349dd7fec$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6Tcuf = parcelRequire("6Tcuf");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb87d90349dd7fec$var$StyledTextComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $cb87d90349dd7fec$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Tcuf.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cb87d90349dd7fec$var$StyledTextComponent, props));

});


parcelRegister("lJU2B", function(module, exports) {
$parcel$export(module.exports, "default", () => $53abab7dcd5cf0f2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $53abab7dcd5cf0f2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    menuButton: {
        "id": "issue-navigator-issue-operations.menu-button",
        "defaultMessage": "Issue operations menu"
    },
    menuButtonLabel: {
        "id": "issue-navigator-issue-operations.menu-button-label",
        "defaultMessage": "More actions for {issueKey}"
    },
    disabledMenuButtonLabel: {
        "id": "issue-navigator-issue-operations.disabled-menu-button-label",
        "defaultMessage": "Disabled more actions button for {issueKey}"
    },
    menuButtonIssueTerminologyRefreshM4: {
        "id": "issue-navigator-issue-operations.menu-button-issue-terminology-refresh-m4",
        "defaultMessage": "Work item operations menu"
    }
});

});

parcelRegister("2jB2v", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bo8ao").then(()=>parcelRequire('kgUsc'));

});



$parcel$global.rlb("8Vl45")
//# sourceMappingURL=async.c064da89.js.map
